// @ts-nocheck

export function convertTime(timestamp) {
    const date = new Date(timestamp * 1000);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    };
    return date.toLocaleString('pt-BR', options);
}

export function getColorClass(quantity, mapQuantityClass) {
    let selectedColor = mapQuantityClass[0];

    for (let colorConfig of mapQuantityClass) {
        if (quantity < colorConfig.quantity) {
            return selectedColor.colorClass
        }

        if (colorConfig.quantity > selectedColor.quantity) {
            selectedColor = colorConfig
        }
    }

    return selectedColor.colorClass;
}
